import { REQUEST_FORM_MANAGERS_FIELD_MAX_ERROR } from '../RequestForm.constants'

export function getAssigneeFieldErrorProps(error) {
  return {
    error: error === REQUEST_FORM_MANAGERS_FIELD_MAX_ERROR ? !!error : error,
  }
}
